import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';

import { Column, Row } from '@xingternal/xing-grid';

import { contextShape } from '../../../../posting-header.proptypes';
import NavigationButton, { LEFT, RIGHT } from '../navigation-button';

import styles from './navigation.css';

const Navigation = ({ context, className }) => (
  <Row size={12} className={classnames(styles.navigation, className)}>
    <Column size={6}>{!R.isNil(context.previous) && <NavigationButton side={LEFT} {...context.previous} />}</Column>
    <Column size={6}>{!R.isNil(context.next) && <NavigationButton side={RIGHT} {...context.next} />}</Column>
  </Row>
);

Navigation.propTypes = {
  context: contextShape,
  className: PropTypes.string,
};

export default Navigation;
